import React from 'react'

export const SuccessSVG = ({width, height}) => {
    return (
        <svg id="Grupo_415" data-name="Grupo 415" xmlns="https://www.w3.org/2000/svg" width={width ? width:"18"} height={height? height:"18"} viewBox="0 0 28 28">
            <g id="Elipse_38" data-name="Elipse 38" transform="translate(0)" fill="#fff" stroke="#fff" style={{ strokeWidth: "1" }} >
                <circle cx="14" cy="14" r="14" stroke="none" />
                <circle cx="14" cy="14" r="13.5" fill="none" />
            </g>
            <path id="Icon_awesome-check-circle" data-name="Icon awesome-check-circle" d="M26.954,13.758a13.2,13.2,0,1,1-13.2-13.2A13.2,13.2,0,0,1,26.954,13.758ZM12.232,20.746l9.791-9.791a.851.851,0,0,0,0-1.2l-1.2-1.2a.851.851,0,0,0-1.2,0L11.63,16.532,7.9,12.8a.851.851,0,0,0-1.2,0l-1.2,1.2a.851.851,0,0,0,0,1.2l5.534,5.534A.851.851,0,0,0,12.232,20.746Z" transform="translate(0.194 0.194)" fill="#00a20b" />
        </svg>

    )
}
